import { useState } from "react"
import { ChangePasswordRequestDto } from "../../Objects/ChangePassword/ChangePasswordRequestDto"
import { ChangeUserPasswordByAdmin } from "../../Objects/ChangePassword/ChangeUserPasswordByAdminDto"

export const useCreateChangePassword = () => {
  const [currentPassword, setCurrentPassword] = useState("")

  const [newPassword, setNewPassword] = useState("")

  const handleCurrentPasswordChange = (e: React.ChangeEvent<HTMLInputElement>) => setCurrentPassword(e.target.value)
  const handleNewPasswordChange = (e: React.ChangeEvent<HTMLInputElement>) => setNewPassword(e.target.value)

  const handleSubmitForm = (isMaster: boolean, employeeId?: number) => {
    if (isMaster) {
      return new ChangeUserPasswordByAdmin({
        employeeId,
        newPassword,
      })
    }

    return new ChangePasswordRequestDto({
      currentPassword,
      newPassword,
    })
  }

  return {
    currentPassword,
    newPassword,
    handleCurrentPasswordChange,
    handleNewPasswordChange,
    handleSubmitForm,
  }
}
